module.exports = __webpack_public_path__ + "static/media/openedCookie.29cca058.webp";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/fortuneCookie/openedCookie.webp
// module id = 1483
// module chunks = 0